export const mapCircleReducer = (state = null, action) => {
    switch (action.type) {
        case 'mapCircle':
            return action.payload
        default:
            return state
    }
}
export default mapCircleReducer;